// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

// Auth
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SIGN_OUT_REQUEST = "AUTH_SIGN_OUT_REQUEST";
export const AUTH_SIGN_OUT_SUCCESS = "AUTH_SIGN_OUT_SUCCESS";
export const AUTH_SIGN_OUT_FAILURE = "AUTH_SIGN_OUT_FAILURE";
export const AUTH_VERIFY_CODE_REQUEST = "AUTH_VERIFY_CODE_REQUEST";
export const AUTH_VERIFY_CODE_SUCCESS = "AUTH_VERIFY_CODE_SUCCESS";
export const AUTH_VERIFY_CODE_FAILURE = "AUTH_VERIFY_CODE_FAILURE";
export const AUTH_SIGN_UP_REQUEST = "AUTH_SIGN_UP_REQUEST";
export const AUTH_SIGN_UP_SUCCESS = "AUTH_SIGN_UP_SUCCESS";
export const AUTH_SIGN_UP_FAILURE = "AUTH_SIGN_UP_FAILURE";
export const AUTH_RESEND_SIGNUP_REQUEST = "AUTH_RESEND_SIGNUP_REQUEST";
export const AUTH_RESEND_SIGNUP_SUCCESS = "AUTH_RESEND_SIGNUP_SUCCESS";
export const AUTH_RESEND_SIGNUP_FAILURE = "AUTH_RESEND_SIGNUP_FAILURE";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";
export const AUTH_FORGOT_PASSWORD_REQUEST = "AUTH_FORGOT_PASSWORD_REQUEST";
export const AUTH_FORGOT_PASSWORD_SUCCESS = "AUTH_FORGOT_PASSWORD_SUCCESS";
export const AUTH_FORGOT_PASSWORD_FAILURE = "AUTH_FORGOT_PASSWORD_FAILURE";
export const AUTH_REGISTER_SUBSCRIPTION_REQUEST = "AUTH_REGISTER_SUBSCRIPTION_REQUEST";
export const AUTH_REGISTER_SUBSCRIPTION_SUCCESS = "AUTH_REGISTER_SUBSCRIPTION_SUCCESS";
export const AUTH_REGISTER_SUBSCRIPTION_FAILURE = "AUTH_REGISTER_SUBSCRIPTION_FAILURE";
